import { useVendors } from '@/composables/app/useVendors'

export default attrs => {
  const { getVendorUrl } = useVendors()

  const { type, input } = attrs

  if (!input) return {}

  if (type === 'video') {
    const src = getVendorUrl({ src: input })

    if (!src) return {}

    return {
      ...attrs,
      src,
      width: 630,
      height: 354,
      allowfullscreen: 0,
      allow: 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture',
      textAlign: 'center'
    }

  } else {
    const parser = new DOMParser()
    const iframe = parser.parseFromString(input, 'text/html').querySelector('iframe')

    if (!iframe) return {}

    return {
      ...attrs,
      src: iframe.getAttribute('src'),
      width: iframe.getAttribute('width'),
      height: iframe.getAttribute('height'),
      frameborder: iframe.getAttribute('frameborder'),
      allowfullscreen: iframe.getAttribute('allowfullscreen'),
      allow: iframe.getAttribute('allow')
    }
  }
}